/**
 * Auto-generated version file.
 * DO NOT EDIT MANUALLY - this file is generated during build.
 * Run `node scripts/generate-version.js` to regenerate.
 */
export const APP_VERSION = {
  VERSION: '2.23.0',
  BUILD_NUMBER: '3031708261',
  COMMIT_HASH: '397986db',
};
